<div class="segment date">
  <ion-input
    #dateInput
    [value]="dateInputValue"
    [placeholder]="self.DATE_PLACEHOLDER"
    [disabled]="disabled"
    [clearInput]="true"
    [maskito]="maskitoDateOptions"
    [maskitoElement]="maskitoMaskPredicate"
    (ionChange)="onDateInputChange()"
    (ionBlur)="onDateInputBlur($event)"
  ></ion-input>
  <ion-icon
    name="calendar-outline"
    id="date-time-input-{{ uuid }}-date-icon"
    (click)="onDateIconClick($event)"
  ></ion-icon>
</div>

<ion-popover #datePopover trigger="date-time-input-{{ uuid }}-date-icon" class="date-time-input-date-popover">
  <ng-template>
    <ion-datetime
      #datePicker
      presentation="date"
      locale="cs-CZ"
      first-day-of-week="1"
      (ionChange)="onDatePickerChange()"
      [(ngModel)]="datePickerValue"
    ></ion-datetime>
  </ng-template>
</ion-popover>
